<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
	<div class="content-body">

		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<div class="card">

			<!-- TABELA DE DADOS -->
			<section id="ngx-datatable-inline-editing">
				<!-- FUNCOES DA TABELA -->
				<div class="row">
					<div class="col-12">
						<button class="btn btn-primary float-right mr-1 mt-1" routerLink="/cliente/cadastro/"
							rippleEffect>
							<i data-feather="plus" class="mr-0 mr-sm-1"></i><span
								class="d-none d-sm-inline-block">Adicionar</span>
						</button>
						<!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                            CSV</a> -->
					</div>
				</div>
				<hr>
				<!-- FILTROS DA TABELA -->
				<div class="row">
					<div class="col-md-6 col-12">
						<div class="d-flex justify-content-between align-items-center m-1">
							<label class="d-flex align-items-center">Mostrar
								<select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="100">100</option>
								</select>
							</label>
						</div>
					</div>

					<!-- <div class="col-md-6 col-12 d-flex justify-content-md-end">
                        <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                            <label class="d-flex align-items-center">Pesquisa<input type="search" placeholder="Campanha"
                                    class="form-control ml-25" (keyup)="updateFilter($event)" /></label>
                        </div>
                    </div> -->
				</div>

				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					[loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Nome Contratante" prop="nome_contratante">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Nome Contratante</h4>
							<input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
								(keyup)="nomeContratanteFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{ formatarNome(row.nome_contratante) }}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Razão Social" prop="razao_social">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Razão Social</h4>
							<input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
								(keyup)="razaoSocialFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{ formatarNome(row.razao_social) }}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Nome Fantasia" prop="nome_fantasia">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Nome Fantasia</h4>
							<input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
								(keyup)="nomeFantasiaFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{ formatarNome(row.nome_fantasia) }}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="CNPJ" prop="cpf_cnpj_cliente">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>CPF/CNPJ</h4>
							<input type="search" placeholder="Pesquisar CNPJ" class="ml-25 form-control"
								(keyup)="cnpjFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{ formatarNome(row.cpf_cnpj_cliente) }}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Teste" prop="flg_teste">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Cliente Teste</h4>
							<input type="search" placeholder="Pesquisar Situação" class="ml-25 form-control"
								(keyup)="testeFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="badge badge-pill" [ngClass]="{
								'badge-light-danger': row.flg_teste == 0,
								'badge-light-success': row.flg_teste == 1
							  }">{{row.flg_teste == 1 ? 'Sim' : 'Não'}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false" name="Status" prop="id_status">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Status</h4>
							<select [(ngModel)]="selectedStatus" (change)="statusFilter()" class="ml-25 form-control">
								<option [value]="-1">Todos</option>
								<option [value]="1">Ativo</option>
								<option [value]="0">Inativo</option>
								<option [value]="4">Bloqueado</option>
								<option [value]="3">Cancelado</option>
							</select>
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="badge badge-pill badge-light-success" *ngIf="row.id_status == 1">Ativo</span>
							<span class="badge badge-pill badge-light-secondary" *ngIf="row.id_status == 0">Inativo</span>
							<span class="badge badge-pill badge-light-warning" *ngIf="row.id_status == 4">Bloqueado</span>
							<span class="badge badge-pill badge-light-danger" *ngIf="row.id_status == 3">Cancelado</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<!-- <ngx-datatable-column [sortable]="false" name="Telefone Contratante" prop="estado">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h4>Estado</h4>
							<input type="search" placeholder="Pesquisar Telefone" class="ml-25 form-control"
								(keyup)="estadoFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span [patterns]="customPatterns" mask="UU" class="font-weight-bold">{{row.estado}}</span>
						</ng-template>
					</ngx-datatable-column> -->

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center">
								<div ngbDropdown container="body">
									<a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
										id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
										aria-expanded="false">
										<i data-feather="more-vertical" class="text-primary cursor-pointer mr-50"></i>
									</a>
									<div ngbDropdownMenu class="dropdown-menu-right"
										aria-labelledby="dropdownBrowserState">
										<a routerLink="/cliente/editar/{{row.id_cliente}}" href="" ngbDropdownItem
											class="d-flex align-items-center"><i data-feather="file-text"
												class="mr-50"></i> Editar</a>
										<!-- <a (click)="msgConfirmacao(row.id_cliente)" ngbDropdownItem
											class="d-flex align-items-center"><i data-feather="trash-2"
												class="mr-50"></i> Excluir</a> -->
									</div>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</section>

		</div>
	</div>
</div>